import { render, staticRenderFns } from "./PalletTop.vue?vue&type=template&id=656bd510&"
import script from "./PalletTop.vue?vue&type=script&lang=js&"
export * from "./PalletTop.vue?vue&type=script&lang=js&"
import style0 from "./PalletTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports